import { render } from "./OnCloseModal.vue?vue&type=template&id=03c8abda"
import script from "./OnCloseModal.vue?vue&type=script&lang=js"
export * from "./OnCloseModal.vue?vue&type=script&lang=js"

import "./OnCloseModal.vue?vue&type=style&index=0&id=03c8abda&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__